import { Radio } from '@mui/material';
import { FormikProps, useFormik } from 'formik';
import { observer } from 'mobx-react-lite';
import { useEffect, useMemo } from 'react';
import { toast } from 'react-toastify';
import { SavedViewDraft } from '../../interfaces/ISavedView';
import SavedViewStore from '../../store/SavedViewStore';
import StringInput from '../inputs/StringInput';
import savedViewsStyles from "./SavedViews.module.css";

function SavedViewsCreate({ savedViewStore, isActive, onSelect, onActiveFormik, onDone }: ISavedViewsCreateProps) {
    const initialValues = useMemo(() => SavedViewDraft.empty(), []);

    const formik = useFormik<SavedViewDraft>({
        initialValues,
        onSubmit: async (values) => {
            await savedViewStore.createSavedView(values);
            toast.success("Successfully!");
            onDone();
        },
    });

    useEffect(() => {
        if (!isActive) {
            formik.resetForm({ values: SavedViewDraft.empty() });
            return;
        }
    }, [isActive]);

    useEffect(() => {
        if (!isActive) return;
        onActiveFormik({ ...formik, values: formik.values });
    }, [isActive, formik.values])

    return (
        <>
            <div className={savedViewsStyles.savedViewOption} onClick={onSelect}>
                <Radio checked={isActive} onChange={onSelect} />
                <div className={savedViewsStyles.savedViewOptionContent}>
                    <div className={savedViewsStyles.savedViewOptionTitle}></div>

                    <div style={!isActive ? { pointerEvents: 'none', opacity: 0.6 } : undefined}>
                        <StringInput
                            formik={formik}
                            name="name"
                            label="ADD VIEW"
                            placeholder="New View"
                            onFocus={onSelect}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}

export default observer(SavedViewsCreate);

interface ISavedViewsCreateProps {
    savedViewStore: SavedViewStore;
    isActive: boolean;
    onSelect: () => void;
    onActiveFormik: (formik: FormikProps<SavedViewDraft> | null) => void;
    onDone: () => void;
}